export const GENERIC_SAVED_MSG = "Saved successfully";
export const GENERIC_DELETED_MSG = "Deleted successfully";
